(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casa-paco-arroz"] && !Shopify.designMode) return;
  try {
    
function cpArrozIniciarCantidad(){
  document.querySelectorAll('.cp-arroz__booking-form').forEach(function(form){
    if(form.dataset.cpQtyReady === 'true') return;
    form.dataset.cpQtyReady = 'true';

    var input = form.querySelector('input[name="quantity"]');
    var minus = form.querySelector('[data-cp-qty-minus]');
    var plus = form.querySelector('[data-cp-qty-plus]');
    if(!input || !minus || !plus) return;

    function normalizar(value){
      var number = parseInt(value, 10);
      if(!Number.isFinite(number)) number = 1;
      return Math.min(30, Math.max(1, number));
    }

    function actualizar(value){
      input.value = normalizar(value);
      minus.disabled = Number(input.value) <= 1;
      plus.disabled = Number(input.value) >= 30;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    minus.addEventListener('click', function(){ actualizar(Number(input.value) - 1); });
    plus.addEventListener('click', function(){ actualizar(Number(input.value) + 1); });
    input.addEventListener('change', function(){
      var clean = normalizar(input.value);
      if(String(clean) !== String(input.value)) input.value = clean;
      minus.disabled = clean <= 1;
      plus.disabled = clean >= 30;
    });

    actualizar(input.value);
  });
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', cpArrozIniciarCantidad);
}else{
  cpArrozIniciarCantidad();
}
document.addEventListener('shopify:section:load', cpArrozIniciarCantidad);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-paco-home-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-rail]');
  if (!b) return;
  var rail = document.getElementById('cp-rail');
  if (!rail) return;
  var step = rail.clientWidth * 0.6;
  rail.scrollBy({ left: b.dataset.rail === 'next' ? step : -step, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-degustacion-temporada"] && !Shopify.designMode) return;
  try {
    
/*
 * BookX añade la reserva mediante AJAX. Solo redirigimos al carrito cuando
 * confirma una reserva del Menú de Temporada, nunca antes de elegir la franja.
 */
function mdtEsReservaAnadida(payload){
  var items = payload && Array.isArray(payload.items) ? payload.items : [payload];
  return items.some(function(item){
    if(!item) return false;
    var variantId = String(item.variant_id || item.id || '');
    var properties = item.properties || {};
    return variantId === '57236723532156' && Boolean(properties['_bookeasy-booking-id']);
  });
}

function mdtIrAlCarrito(payload){
  if(!mdtEsReservaAnadida(payload)) return;
  window.setTimeout(function(){ window.location.assign('/cart'); }, 700);
}

function mdtInstalarRedireccion(){
  if(window.__mdtCartRedirectInstalled) return;
  window.__mdtCartRedirectInstalled = true;

  var originalOpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function(method, url){
    var isCartAdd = typeof url === 'string' && /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url);
    if(isCartAdd){
      this.addEventListener('load', function(){
        if(this.status < 200 || this.status >= 300) return;
        try { mdtIrAlCarrito(JSON.parse(this.responseText)); } catch(error) {}
      });
    }
    return originalOpen.apply(this, arguments);
  };

  var originalFetch = window.fetch;
  if(typeof originalFetch === 'function'){
    window.fetch = function(resource, options){
      var requestUrl = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      var responsePromise = originalFetch.apply(this, arguments);
      if(/\/cart\/add(?:\.js)?(?:[?#]|$)/.test(requestUrl)){
        responsePromise.then(function(response){
          if(!response.ok) return;
          response.clone().json().then(mdtIrAlCarrito).catch(function(){});
        }).catch(function(){});
      }
      return responsePromise;
    };
  }
}

function mdtIniciarCantidad(){
  document.querySelectorAll('.mdt-booking-form').forEach(function(form){
    if(form.dataset.mdtQtyReady === 'true') return;
    form.dataset.mdtQtyReady = 'true';

    var input = form.querySelector('input[name="quantity"]');
    var minus = form.querySelector('[data-mdt-qty-minus]');
    var plus = form.querySelector('[data-mdt-qty-plus]');
    if(!input || !minus || !plus) return;

    function normalizar(value){
      var number = parseInt(value, 10);
      if(!Number.isFinite(number)) number = 1;
      return Math.min(30, Math.max(1, number));
    }

    function actualizar(value){
      input.value = normalizar(value);
      minus.disabled = Number(input.value) <= 1;
      plus.disabled = Number(input.value) >= 30;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    minus.addEventListener('click', function(){ actualizar(Number(input.value) - 1); });
    plus.addEventListener('click', function(){ actualizar(Number(input.value) + 1); });
    input.addEventListener('change', function(){
      var clean = normalizar(input.value);
      if(String(clean) !== String(input.value)) input.value = clean;
      minus.disabled = clean <= 1;
      plus.disabled = clean >= 30;
    });

    actualizar(input.value);
  });
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', function(){
    mdtInstalarRedireccion();
    mdtIniciarCantidad();
  });
}else{
  mdtInstalarRedireccion();
  mdtIniciarCantidad();
}
document.addEventListener('shopify:section:load', mdtIniciarCantidad);

  } catch(e) { console.error(e); }
})();
})();
